module.exports = __webpack_public_path__ + "img/appointmentFail.34e5aafc.png";